export function getUserProfile() {
  try {
    const raw = sessionStorage.getItem('userProfile');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isOwnerScope() {
  return getUserProfile()?.roleScope === 'OWNER';
}
